import React, { memo, useEffect } from "react";

import {
  Autocomplete,
  FormControl,
  IconButton,
  InputAdornment,
  TableCell,
  TableRow,
  TextField,
} from "@mui/material";

import { useState } from "react";
import { withRouter } from "react-router";

import {
  CalendarToday,
  Cancel,
  Check,
  Create,
  Delete,
  DeleteForever,
} from "@mui/icons-material";

import { trimPropsItem } from "../../../../../config/const";
import {
  useRowStyles,
  butonIconTransition,
} from "../../../../../styles/stylesRows";
import ConfirmacionDialog from "../../../../components/Dialogs/ConfirmacionDialog";
import ButtonsAction from "../../../../components/Tablas/ButtonsAction";

import CalendarioPlus from "../../../../components/Calendario/CalendarioPlus";
import { set } from "date-fns";
const RowHorario = (props) => {
  // PROPS
  const {
    setitemPadre,
    itemPadre,
    rowHijo,
    index,
    editarPadre,
    ubicacionesData,
  } = props;
  // CLASES
  const classes = useRowStyles();
  const claseCelda = `${
    index % 2 === 0 ? classes.celda : classes.celdaSecundario
  } ${rowHijo.error === true ? classes.celdaEliminado : ""}`;

  // STATE
  const [editar, seteditar] = useState(false);
  const [itemHijo, setitemHijo] = useState(rowHijo);
  const [openConfirmDialog, setopenConfirmDialog] = useState(false);
  //onChange
  const handleChange = (e) => {
    setitemHijo({ ...itemHijo, [e.target.name]: e.target.value });
  };

  // ELIMINAR EL REGISTRO
  const funcSubmit = () => {
    try {
      const horarios = itemPadre.horarios.map((item, itemIndex) => {
        const { nuevo, ...rest } = itemHijo;
        if (item.id === itemHijo.id) {
          return trimPropsItem({ ...rest, order: rowHijo.order });
        } else {
          return item;
        }
      });
      console.log(horarios);

      setitemPadre({
        ...itemPadre,
        horarios,
      });

      seteditar(false);
    } catch (error) {}
  };
  const funcEliminar = () => {
    try {
      setitemPadre({
        ...itemPadre,
        horarios: itemPadre.horarios.filter(
          (item, indexItem) => item.id !== rowHijo.id,
        ),
      });
      setopenConfirmDialog(false);
    } catch (error) {}
  };
  const botones = [
    {
      tooltip: "Eliminar",
      texto: "",
      funcion: () => {
        setopenConfirmDialog(true);
      },
      disabled: false,
      Icon: Delete,
      color: "error",
      id: 1,
      ocultar: false,
      tipo: "icono",
      variante: "contained",
      size: "small",
      sx: butonIconTransition,
      submit: true,
    },
    {
      tooltip: "Editar",
      texto: "",
      funcion: () => {
        seteditar(true);
        setitemHijo(rowHijo);
      },
      disabled: false,
      Icon: Create,
      color: "secondary",
      id: 2,
      ocultar: false,
      tipo: "icono",
      variante: "contained",
      size: "small",
      sx: { ...butonIconTransition, padding: "0" },
    },
  ];
  const botonesEditar = [
    {
      tooltip: "Cancelar",
      texto: "",
      funcion: () => {
        if (rowHijo.nuevo) {
          return funcEliminar();
        }
        seteditar(false);
        setitemHijo(rowHijo);
        // setItemEdit(rowHijo);
      },
      disabled: false,
      Icon: Cancel,
      color: "error",
      id: 1,
      ocultar: false,
      tipo: "icono",
      variante: "contained",
      size: "small",
      sx: { ...butonIconTransition, padding: "0" },
    },
    {
      tooltip: "Guardar",
      texto: "",
      funcion: () => {
        funcSubmit();
      },
      disabled: false,
      Icon: Check,
      color: "success",
      id: 2,
      ocultar: false,
      tipo: "icono",
      variante: "contained",
      size: "small",
      sx: butonIconTransition,
      submit: true,
    },
  ];
  const [openCalendario, setopenCalendario] = useState(false);
  const [focusedDate, setFocusedDate] = useState("");
  useEffect(() => {
    if (rowHijo.nuevo) {
      seteditar(true);
    }
    // eslint-disable-next-line
  }, [rowHijo]);
  console.log({ itemHijo });

  return (
    <TableRow
      className={classes.root}
      component={"form"}
      onSubmit={(e) => {
        e.preventDefault();
      }}
      // onDragStart={() => handleDragStart(index)}
      // onDragEnter={() => {
      //   handleDragEnter(index);
      // }}
      // onDragEnd={(e) =>
      //   handleDragEnd(
      //     "horarios",
      //     itemPadre.horarios,
      //     itemPadre,
      //     setitemPadre
      //   )
      // }
      // onDragOver={(e) => e.preventDefault()}
      // draggable
    >
      <ConfirmacionDialog
        open={openConfirmDialog}
        setopen={setopenConfirmDialog}
        categoria="warning"
        titulo={`¿Esta seguro de eliminar este registro?`}
        botones={[
          {
            tooltip: "Se eliminaran los registros",
            texto: "SI",
            funcion: () => {
              funcEliminar();
            },
            disabled: false,
            Icon: DeleteForever,
            color: "error",
            id: 1,
            ocultar: false,
            tipo: "boton",
            variante: "contained",
            size: "medium",
            sx: { marginRight: ".3rem" },
          },
          {
            tooltip: "Cancelar",
            texto: "NO",
            funcion: () => {
              setopenConfirmDialog(false);
            },
            disabled: false,
            Icon: Cancel,
            color: "secondary",
            id: 2,
            ocultar: false,
            tipo: "boton",
            variante: "contained",
            size: "medium",
            sx: {},
          },
        ]}
      />
      <ButtonsAction
        claseCelda={claseCelda}
        botones={editar ? botonesEditar : botones}
      />{" "}
      <CalendarioPlus
        sinValidacionTurno
        propiedad={itemHijo.fechas_iso}
        propiedadDB={itemHijo.fechas_iso}
        focusedDate={focusedDate}
        setFocusedDate={setFocusedDate}
        item={itemHijo}
        setitem={(e) => {
          setitemHijo(e);
          // setitem({
          //   ...item,
          //   horarios: item.horarios.map((item) => {
          //     if (item.id === turno.id) {
          //       return e;
          //     } else {
          //       return item;
          //     }
          //   }),
          // });
        }}
        TextoPropiedad={"fechas_milisegundos"}
        textoPropiedadDB={"fechas_iso"}
        openCalendario={openCalendario}
        setopenCalendario={setopenCalendario}
      />{" "}
      {editar ? (
        <>
          {/* <TextField
              autoComplete="false"
              value={itemHijo.item}
              name="item"
              onChange={(e) => {}}
              size="small"
              fullWidth
            /> */}
          <TableCell size="small" align="center" className={claseCelda}>
            <FormControl fullWidth>
              <Autocomplete
                filterOptions={(x) => x}
                options={ubicacionesData.map((item) => {
                  return item.ubicacion + "/+/" + item.puesto + "/+/" + item.id;
                })}
                getOptionLabel={(option) => {
                  return option.split("/+/")[0];
                }}
                id="controlled-demo"
                value={itemHijo.ubicacion}
                paperprops
                onChange={async (event, newValue) => {
                  if (newValue) {
                    const options = newValue.split("/+/");
                    console.log({ options });
                    console.log(itemHijo);

                    setitemHijo({
                      ...itemHijo,
                      ubicacion: options[0],
                      id_horario_ubicacion: options[2],
                    });
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    required
                    // label={"Ubicación"}
                    fullWidth
                    // error={error.actaEntDoc}
                  />
                )}
              />
            </FormControl>
          </TableCell>

          <TableCell size="small" align="center" className={claseCelda}>
            <TextField
              fullWidth
              multiline
              rows={2}
              size="small"
              // label="Fechas"
              value={itemHijo.fechas_iso
                .map(
                  (itemFecha) =>
                    `${itemFecha.desde
                      .substr(0, 16)
                      .replace("T", "-")}, ${itemFecha.hasta
                      .substr(0, 16)
                      .replace("T", "-")}`,
                )
                .join(" || ")}
              // name="dia"
              InputProps={{
                endAdornment: (
                  <InputAdornment>
                    <IconButton
                      aria-label=""
                      onClick={() => {
                        setopenCalendario(true);
                      }}
                    >
                      <CalendarToday color="secondary" />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </TableCell>
        </>
      ) : (
        <>
          <TableCell size="small" align="center" className={claseCelda}>
            {itemHijo.ubicacion}
          </TableCell>
          <TableCell size="small" align="center" className={claseCelda}>
            {rowHijo.fechas_iso
              .map(
                (itemFecha) =>
                  `${itemFecha.desde
                    .substr(0, 16)
                    .replace("T", "-")}, ${itemFecha.hasta
                    .substr(0, 16)
                    .replace("T", "-")}`,
              )
              .join(" || ")}
          </TableCell>
        </>
      )}
    </TableRow>
  );
};

export default withRouter(memo(RowHorario));
